export const CDC_HOST_PREFIX = '%P1.2%V';

/**
 * Normalize the label delivered by a connected scanner.
 *
 * Existing CDC-host scanners may prefix labels with %P1.2%V and terminate
 * them with CR/LF. Symbol PID 1701 scanners deliver the label as raw ASCII
 * without either framing convention.
 */
export const normalizeScannerPayload = (payload) => {
  if (payload === null || payload === undefined) return '';

  const trimmedPayload = String(payload).replace(/\0/g, '').trim();

  if (trimmedPayload.startsWith(CDC_HOST_PREFIX)) {
    return trimmedPayload.substring(CDC_HOST_PREFIX.length).trim();
  }

  return trimmedPayload;
};
